import { Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SiAccordionModule } from '@siemens/element-ng/accordion';
import { SiCardModule } from '@siemens/element-ng/card';

@Component({
  selector: 'app-tables',
  imports: [SiCardModule, SiAccordionModule, TranslateModule],
  templateUrl: './tables.component.html',
  styleUrl: './tables.component.scss'
})
export class TablesComponent {
  readonly results = input.required<any>();
  readonly resultTable = computed(() => this.results().result_table);
  readonly resultEnergyConsumption = computed(() => this.results().energy_consumption_results);
  readonly vehicleType = computed(() => this.results().vehicle_type);
}
